import { Link } from "react-router-dom";
import iconoSvg from "../image/icono.svg";
import nexoSistema from "../image/NexoSistema.jpg";
import { ChevronRight, Cpu, Lock, Zap, BarChart3, Wifi, Shield, Phone, MapPin, Mail } from "lucide-react";
import { Button } from "../components/Button";
import imagen from "../image/Azul.jpg";
import sensor from "../image/ciudadSensores.png";
import dash from "../image/DashboardMobile.png";
import calera from "../image/Calera.png";
import logo from "../image/logo.jpg";
import ContactForm from "../components/ContactForm";

export function HomePage() {

  return (
    <div className="flex min-h-screen flex-col">
       <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
        <div className="w-full flex h-20 items-center justify-between px-6 mr-8">
          <div className="flex items-center gap-2">
            <img
                src={iconoSvg}
                width={24}
                height={24}
                margin={2}
                className="h-5 w-5 ml-4"
                alt="Estrella"
              />
              <span className="text-xl font-semibold">NexoIoT</span>
          </div>
          <nav className="hidden md:flex gap-6 ml-8">
            <a href="#features" className="text-base font-medium text-gray-600 hover:text-gray-900 scroll-smooth">
                Características
              </a>
              <a href="#products" className="text-base font-medium text-gray-600 hover:text-gray-900 scroll-smooth">
                Productos
              </a>
              <a href="#testimonials" className="text-base font-medium text-gray-600 hover:text-gray-900 scroll-smooth">
                Casos de éxito
              </a>
              <a href="#contact" className="text-base font-medium text-gray-600 hover:text-gray-900 scroll-smooth">
                Contacto
              </a>
          </nav>         
        </div>
       </header>
         {/* Main */}
       <main className="flex-1">
      


         {/* Hero Section */}
        <section className="relative overflow-hidden py-16 md:py-24 bg-gradient-to-br from-blue-50 via-white to-indigo-50 mb-16">
          <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
          <div className="relative w-full max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-12">
        
        {/* Columna izquierda */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            {/* Contenido izquierdo */}
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-4">
                <Zap className="w-4 h-4 mr-2" />
                Tecnología del Futuro
              </div>
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl text-gray-900 leading-tight">
                Impulsando el <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Futuro</span> con Soluciones IoT
              </h1>
              <p className="text-gray-600 text-lg md:text-xl leading-relaxed max-w-2xl">
                Soluciones IoT de vanguardia diseñadas para transformar su
                hogar y negocio con tecnología inteligente, segura y escalable.
              </p>
            </div>    
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a href="#products" className="scroll-smooth">
                <Button className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-8 py-4 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <span className="flex items-center">
                    Descubrir productos
                    <ChevronRight className="ml-2 h-5 w-5" />
                  </span>
                </Button>
              </a>
              <a href="#contact" className="scroll-smooth">
                <Button className="bg-white text-gray-700 border-2 border-gray-300 hover:border-gray-400 px-8 py-4 text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                  Contactar ahora
                </Button>
              </a>
            </div>
          </div>

          {/* Columna derecha */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-full max-w-[600px] h-[400px] overflow-hidden rounded-2xl bg-gradient-to-br from-gray-100 to-gray-200 shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-indigo-600/10"></div>
              <img
                src={imagen}
                alt="Dispositivo IoT"
                className="w-full h-full object-cover rounded-2xl"
                priority
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-gray-900/10 rounded-2xl"></div>
            </div>
          </div>

          </div>
        </section>

         {/* Features Section */}
         <section id="features" className="relative py-20 bg-gradient-to-b from-white to-gray-50">
            <div className="container px-4 md:px-6 mx-auto">
              <div className="flex flex-col items-center justify-center space-y-8 text-center">
                <div className="space-y-6 max-w-4xl mx-auto">
                  <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 rounded-full text-sm font-medium">
                    <BarChart3 className="w-4 h-4 mr-2" />
                    Características
                  </div>
                  <h2 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-gray-900">
                    ¿Por qué elegir un <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">sistema IoT</span>?
                  </h2>
                  <p className="max-w-3xl mx-auto text-gray-600 text-lg md:text-xl leading-relaxed">
                    Conectividad total y control en tiempo real. Nuestros sistemas
                    IoT ofrecen una solución robusta, flexible y siempre online,
                    ideal para entornos comerciales e industriales. Monitoreá
                    líquidos, energía, temperatura, humedad y más, con sensores
                    digitales y analógicos de alta precisión.
                  </p>
                </div>
              </div>
            </div>

            {/* Feature Cards */}
            <div className="container px-4 md:px-6 mx-auto mt-16">
              <div className="grid max-w-6xl mx-auto gap-8 lg:grid-cols-3">
                <div className="group relative overflow-hidden rounded-2xl bg-white p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 opacity-50"></div>
                  <div className="relative">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white mb-6">
                      <Lock className="h-8 w-8" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">Seguridad avanzada</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Protección de datos de nivel empresarial con cifrado de
                      extremo a extremo y autenticación multifactor.
                    </p>
                  </div>
                </div>

                <div className="group relative overflow-hidden rounded-2xl bg-white p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-emerald-50 opacity-50"></div>
                  <div className="relative">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-green-600 to-emerald-600 text-white mb-6">
                      <Zap className="h-8 w-8" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">Eficiencia energética</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Optimizado para un consumo mínimo de energía sin comprometer
                      el rendimiento ni la funcionalidad.
                    </p>
                  </div>
                </div>

                <div className="group relative overflow-hidden rounded-2xl bg-white p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-50 to-violet-50 opacity-50"></div>
                  <div className="relative">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-purple-600 to-violet-600 text-white mb-6">
                      <Wifi className="h-8 w-8" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">Conectividad perfecta</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Integración sin problemas con todos sus dispositivos y
                      plataformas existentes en tiempo real.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

           {/* Nuestra linea de productos */}
        <section id="products" className="relative py-24 bg-white">
        <div className="container px-4 md:px-6">
          <div className="flex flex-col items-center justify-center space-y-8 text-center">
                <div className="space-y-6">
                  <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-800 rounded-full text-sm font-medium">
                    <Cpu className="w-4 h-4 mr-2" />
                    Productos
                  </div>
                  <h2 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-gray-900">
                    Nuestra línea de <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">productos</span>
                  </h2>
                  <p className="max-w-3xl mx-auto text-gray-600 text-lg md:text-xl leading-relaxed">
                    Descubra nuestra gama de dispositivos IoT diseñados para
                    transformar su experiencia digital con tecnología de vanguardia.
                  </p>
                </div>
              </div>
          </div>
          <div className="grid gap-8 py-16 md:grid-cols-2 lg:grid-cols-3 justify-items-center max-w-6xl mx-auto">
            <div className="group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 max-w-sm mx-auto border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-100 opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="aspect-video overflow-hidden rounded-t-2xl">
                <img
                  src={nexoSistema}
                  alt="IoT Hub"
                  width={300}
                  height={150}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="relative p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-2 h-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full"></div>
                  <span className="text-xs font-medium text-blue-600 uppercase tracking-wide">Hardware</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Thunder IoT</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Centro de control inteligente para todos sus dispositivos IoT con conectividad avanzada.
                </p>
                <a href="#placas" className="scroll-smooth">
                  <Button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium py-2.5 rounded-lg transition-all duration-300">
                    Más información
                  </Button>
                </a>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 max-w-sm mx-auto border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-emerald-100 opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="aspect-video overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6 rounded-t-2xl">
                <img
                  src={sensor}
                  alt="Sensor inteligente"
                  width={728}
                  height={728}
                  className="max-w-[85%] max-h-[85%] object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="relative p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-2 h-2 bg-gradient-to-r from-green-600 to-emerald-600 rounded-full"></div>
                  <span className="text-xs font-medium text-green-600 uppercase tracking-wide">Sensores</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sensores IoT</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Monitoreo preciso y en tiempo real para ambientes diversos con alta precisión.
                </p>
                <a href="#sensores" className="scroll-smooth">
                  <Button className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-medium py-2.5 rounded-lg transition-all duration-300">
                    Más información
                  </Button>
                </a>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 max-w-sm mx-auto border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-50 to-violet-100 opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="aspect-video overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6 rounded-t-2xl">
                <img
                  src={dash}
                  alt="Software de monitoreo"
                  width={728}
                  height={728}
                  className="max-w-[85%] max-h-[85%] object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="relative p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-2 h-2 bg-gradient-to-r from-purple-600 to-violet-600 rounded-full"></div>
                  <span className="text-xs font-medium text-purple-600 uppercase tracking-wide">Software</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Software Monitoreo</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Dashboard intuitivo para seguimiento preciso de variables en tiempo real.
                </p>
                <a href="#software" className="scroll-smooth">
                  <Button className="w-full bg-gradient-to-r from-purple-600 to-violet-600 hover:from-purple-700 hover:to-violet-700 text-white font-medium py-2.5 rounded-lg transition-all duration-300">
                    Más información
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="bg-black py-20 text-white">
          <div className="container px-4 md:px-6">
            <div className="grid gap-10 md:grid-cols-3">
              <div className="flex flex-col items-center space-y-2 text-center">
                <BarChart3 className="h-12 w-12" />
                <h3 className="text-3xl font-bold">99.9%</h3>
                <p className="text-gray-400">Tiempo de actividad garantizado</p>
              </div>
              <div className="flex flex-col items-center space-y-2 text-center">
                <Lock className="h-12 w-12" />
                <h3 className="text-3xl font-bold">256-bit</h3>
                <p className="text-gray-400">Cifrado de seguridad</p>
              </div>
              <div className="flex flex-col items-center space-y-2 text-center">
                <Shield className="h-12 w-12" />
                <h3 className="text-3xl font-bold">1 años</h3>
                <p className="text-gray-400">Garantía de hardware</p>
              </div>
            </div>
          </div>
        </section>

         {/* Testimonials - Casos de Éxito */}
         <section id="testimonials" className="relative py-24 bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
          <div className="absolute top-10 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
          
          <div className="relative container px-4 md:px-6">
            <div className="flex flex-col items-center justify-center space-y-6 text-center mb-16">
              <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 rounded-full text-sm font-medium mb-4">
                <BarChart3 className="w-4 h-4 mr-2" />
                Casos de Éxito
              </div>
              <div className="space-y-4">
                <h2 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl bg-gradient-to-r from-gray-900 via-blue-800 to-indigo-800 bg-clip-text text-transparent">
                  Casos de Éxito
                </h2>
                <p className="max-w-3xl text-gray-600 text-lg md:text-xl leading-relaxed">
                  Descubra por qué nuestros clientes confían en nosotros para transformar sus operaciones con tecnología IoT de vanguardia.
                </p>
              </div>
            </div>
            
            <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-2 lg:gap-12">
              {/* Caso 1 - Municipio La Calera */}
              <div className="group relative overflow-hidden rounded-2xl bg-white/80 backdrop-blur-sm border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-indigo-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-indigo-500"></div>
                
                <div className="relative p-8">
                  {/* Rating Stars */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="relative">
                        <img
                          src={iconoSvg}
                          width={20}
                          height={20}
                          className="h-5 w-5 text-yellow-400 transition-transform duration-300 group-hover:scale-110"
                          style={{ animationDelay: `${i * 100}ms` }}
                          alt="Estrella"
                        />
                      </div>
                    ))}
                  </div>

                  {/* Quote */}
                  <div className="relative mb-8">
                    <div className="absolute -top-2 -left-2 text-6xl text-blue-200 font-serif">"</div>
                    <p className="text-gray-700 text-lg leading-relaxed pl-6 italic">
                      Monitoreo inteligente y en tiempo real de 33 cisternas en
                      el municipio de montaña Calera. Un sistema hídrico
                      estratégico donde cualquier falla en una cisterna puede
                      generar cortes de agua que afectan a gran parte de la
                      población. Nuestra solución garantiza control, prevención y
                      abastecimiento continuo.
                    </p>
                    <div className="absolute -bottom-4 -right-2 text-6xl text-blue-200 font-serif rotate-180">"</div>
                  </div>

                  {/* Client Info */}
                  <div className="flex items-center p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                    <div className="relative">
                      <div className="rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 p-0.5">
                        <img
                          src={calera}
                          alt="Municipio La Calera"
                          className="h-14 w-14 rounded-full object-cover bg-white p-0.5"
                        />
                      </div>
                      <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white"></div>
                    </div>
                    <div className="ml-4 flex-1">
                      <p className="text-base font-semibold text-gray-900">
                        Municipio La Calera
                      </p>
                      <p className="text-sm text-gray-600 flex items-center">
                        <MapPin className="w-4 h-4 mr-1 text-blue-500" />
                        Córdoba, Argentina
                      </p>
                      <div className="flex items-center mt-1">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        <span className="text-xs text-blue-600 font-medium">Sistema Hídrico</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Demo Button */}
                  <div className="mt-6">
                    <Link to="/calera-demo">
                      <div className="group/btn flex items-center justify-center w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                        <span className="mr-2">Ver Demo Interactivo</span>
                        <ChevronRight className="w-5 h-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              {/* Caso 2 - TVE */}
              <div className="group relative overflow-hidden rounded-2xl bg-white/80 backdrop-blur-sm border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-50/50 to-violet-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 to-violet-500"></div>
                
                <div className="relative p-8">
                  {/* Rating Stars */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="relative">
                        <img
                          src={iconoSvg}
                          width={20}
                          height={20}
                          className="h-5 w-5 text-yellow-400 transition-transform duration-300 group-hover:scale-110"
                          style={{ animationDelay: `${i * 100}ms` }}
                          alt="Estrella"
                        />
                      </div>
                    ))}
                  </div>

                  {/* Quote */}
                  <div className="relative mb-8">
                    <div className="absolute -top-2 -left-2 text-6xl text-purple-200 font-serif">"</div>
                    <p className="text-gray-700 text-lg leading-relaxed pl-6 italic">
                      Sistema inteligente de monitoreo para elevadores verticales
                      y horizontales en entornos residenciales y comerciales.
                      Control total en tiempo real de variables críticas y de
                      mantenimiento, anticipando fallas y mejorando la seguridad y
                      eficiencia operativa.
                    </p>
                    <div className="absolute -bottom-4 -right-2 text-6xl text-purple-200 font-serif rotate-180">"</div>
                  </div>

                  {/* Client Info */}
                  <div className="flex items-center p-4 bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl border border-purple-100">
                    <div className="relative">
                      <div className="rounded-full bg-gradient-to-r from-purple-500 to-violet-500 p-0.5">
                        <img
                          src={logo}
                          alt="TVE Logo"
                          className="h-14 w-14 rounded-full object-cover bg-white p-0.5"
                        />
                      </div>
                      <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white"></div>
                    </div>
                    <div className="ml-4 flex-1">
                      <p className="text-base font-semibold text-gray-900">
                        TVE
                      </p>
                      <p className="text-sm text-gray-600 flex items-center">
                        <MapPin className="w-4 h-4 mr-1 text-purple-500" />
                        CABA, Argentina
                      </p>
                      <div className="flex items-center mt-1">
                        <div className="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
                        <span className="text-xs text-purple-600 font-medium">Elevadores Inteligentes</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Demo Button */}
                  <div className="mt-6">
                    <Link to="/tve-demo">
                      <div className="group/btn flex items-center justify-center w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-violet-600 hover:from-purple-700 hover:to-violet-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                        <span className="mr-2">Ver Demo Interactivo</span>
                        <ChevronRight className="w-5 h-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom CTA */}
            
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-gray-50 py-20">
          <div className="container px-4 md:px-6">
            <div className="flex flex-col items-center justify-center space-y-4 text-center">
              <div className="space-y-2">
                <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">
                  Listo para transformar su espacio
                </h2>
                <p className="max-w-[600px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
                  Únase a miles de clientes satisfechos que han mejorado sus
                  hogares y negocios con nuestras soluciones IoT.
                </p>
              </div>
            </div>
          </div>
        </section>

         {/* Products Section */}
         <section id="testimonials" className="relative py-24 bg-gradient-to-br from-gray-50 via-white to-blue-50 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
          
          <div className="relative container px-4 md:px-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 rounded-full text-sm font-medium mb-6">
                <Cpu className="w-4 h-4 mr-2" />
                Soluciones Integrales
              </div>
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6">
                Nuestros <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Productos</span>
              </h2>
              <p className="max-w-3xl mx-auto text-xl text-gray-600 leading-relaxed">
                Ofrecemos soluciones integrales que combinan hardware de última generación,
                sensores inteligentes y software avanzado para un control total del sistema.
              </p>
            </div>

            {/* Products Grid */}
            <div className="space-y-20">
              {/* Thunder IoT */}
              <div id="placas" className="group">
                <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-indigo-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="relative p-8 md:p-12">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                      <div className="md:w-1/2">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-3 h-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full"></div>
                          <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider">Hardware Avanzado</span>
                        </div>
                        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                          Thunder IoT
                        </h3>
                        <p className="text-lg text-gray-600 leading-relaxed mb-8">
                          Nuestros sistemas IoT brindan información precisa y en tiempo real sobre las variables más importantes de tu operación. Diseñados para estar siempre conectados, te permiten supervisar, anticipar y actuar con rapidez, mejorando la eficiencia y la toma de decisiones en entornos comerciales e industriales.
                        </p>
                        <div className="flex flex-wrap gap-3">
                          <div className="flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
                            <Wifi className="w-4 h-4 mr-2" />
                            Conectividad 24/7
                          </div>
                          <div className="flex items-center px-4 py-2 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium">
                            <BarChart3 className="w-4 h-4 mr-2" />
                            Análisis en Tiempo Real
                          </div>
                        </div>
                      </div>
                      <div className="md:w-1/2">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-indigo-600 rounded-2xl transform rotate-3 opacity-20"></div>
                          <img
                            src={nexoSistema}
                            alt="Thunder IoT System"
                            className="relative w-full h-64 md:h-80 object-cover rounded-2xl shadow-lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sensores */}
              <div id="sensores" className="group">
                <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-green-50/50 to-emerald-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="relative p-8 md:p-12">
                    <div className="flex flex-col md:flex-row-reverse items-center gap-8">
                      <div className="md:w-1/2">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-3 h-3 bg-gradient-to-r from-green-600 to-emerald-600 rounded-full"></div>
                          <span className="text-sm font-semibold text-green-600 uppercase tracking-wider">Sensores Inteligentes</span>
                        </div>
                        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                          Sensores IoT
                        </h3>
                        <p className="text-lg text-gray-600 leading-relaxed mb-8">
                          Ofrecemos sensado inteligente de variables digitales y analógicas, adaptado a las necesidades de cada aplicación. Desde contactos magnéticos y switches hasta mediciones precisas de nivel, voltaje, corriente, temperatura y humedad, nuestros sistemas capturan datos críticos en tiempo real, directamente desde el terreno.
                        </p>
                        <div className="flex flex-wrap gap-3">
                          <div className="flex items-center px-4 py-2 bg-green-50 text-green-700 rounded-full text-sm font-medium">
                            <Zap className="w-4 h-4 mr-2" />
                            Alta Precisión
                          </div>
                          <div className="flex items-center px-4 py-2 bg-emerald-50 text-emerald-700 rounded-full text-sm font-medium">
                            <Shield className="w-4 h-4 mr-2" />
                            Resistente
                          </div>
                        </div>
                      </div>
                      <div className="md:w-1/2">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-emerald-600 rounded-2xl transform -rotate-3 opacity-20"></div>
                          <img
                            src={sensor}
                            alt="Sensores IoT"
                            className="relative w-full h-64 md:h-80 object-contain rounded-2xl bg-gradient-to-br from-gray-50 to-gray-100 p-6"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Software */}
              <div id="software" className="group">
                <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-50/50 to-violet-100/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="relative p-8 md:p-12">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                      <div className="md:w-1/2">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-3 h-3 bg-gradient-to-r from-purple-600 to-violet-600 rounded-full"></div>
                          <span className="text-sm font-semibold text-purple-600 uppercase tracking-wider">Software Avanzado</span>
                        </div>
                        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                          Software de Monitoreo IoT
                        </h3>
                        <p className="text-lg text-gray-600 leading-relaxed mb-6">
                          Nuestro software fue desarrollado para ofrecerte una experiencia de gestión ágil, clara y potente. Desde cualquier dispositivo —PC, Android o iOS— podés monitorear tu sistema en tiempo real, ejecutar acciones remotas y recibir notificaciones push instantáneas ante cualquier evento crítico.
                        </p>
                        <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-2xl p-6 mb-8">
                          <h4 className="text-xl font-bold text-gray-900 mb-3">
                            El poder del IoT, en la palma de tu mano.
                          </h4>
                          <p className="text-gray-600">
                            Control total desde cualquier lugar, siempre conectado.
                          </p>
                        </div>
                        <div className="flex flex-wrap gap-3">
                          <div className="flex items-center px-4 py-2 bg-purple-50 text-purple-700 rounded-full text-sm font-medium">
                            <Phone className="w-4 h-4 mr-2" />
                            Multiplataforma
                          </div>
                          <div className="flex items-center px-4 py-2 bg-violet-50 text-violet-700 rounded-full text-sm font-medium">
                            <BarChart3 className="w-4 h-4 mr-2" />
                            Dashboard Intuitivo
                          </div>
                        </div>
                      </div>
                      <div className="md:w-1/2">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-br from-purple-400 to-violet-600 rounded-2xl transform rotate-3 opacity-20"></div>
                          <img
                            src={dash}
                            alt="Software de Monitoreo"
                            className="relative w-full h-64 md:h-80 object-contain rounded-2xl bg-gradient-to-br from-gray-50 to-gray-100 p-6"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </section>

          {/* Contact Section */}
        <section id="contact" className="relative py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 overflow-hidden">
          {/* Background Effects */}
          <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-4000"></div>
          
          <div className="relative container px-4 md:px-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm font-medium mb-6">
                <Mail className="w-4 h-4 mr-2" />
                Conectemos
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                ¿Listo para <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">comenzar</span>?
              </h2>
              <p className="max-w-2xl mx-auto text-xl text-blue-100 leading-relaxed">
                Estamos aquí para ayudarte a transformar tu visión en realidad con nuestras soluciones IoT.
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Contact Info */}
              <div className="space-y-8">
                <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
                  <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                    <div className="w-3 h-3 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full mr-3"></div>
                    Póngase en contacto
                  </h3>
                  <p className="text-blue-100 mb-8 text-lg">
                    ¿Tenés alguna consulta o querés más información? Estamos disponibles en nuestras oficinas de Buenos Aires y Córdoba.
                  </p>
                  
                  {/* Offices */}
                  <div className="grid md:grid-cols-2 gap-8">
                    {/* CABA Office */}
                    <div className="group">
                      <div className="bg-gradient-to-br from-blue-500/20 to-indigo-600/20 rounded-2xl p-6 border border-blue-400/20 hover:border-blue-400/40 transition-all duration-300">
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mr-4">
                            <MapPin className="w-6 h-6 text-white" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold text-lg">Buenos Aires</h4>
                            <p className="text-blue-200 text-sm">Oficina Principal</p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center text-blue-100">
                            <Phone className="w-4 h-4 mr-3 text-blue-400" />
                            <span className="text-sm">+54 9 11 54577992</span>
                          </div>
                          <div className="flex items-center text-blue-100">
                            <MapPin className="w-4 h-4 mr-3 text-blue-400" />
                            <span className="text-sm">CABA, Argentina</span>
                          </div>
                          <div className="flex items-center text-blue-100">
                            <Mail className="w-4 h-4 mr-3 text-blue-400" />
                            <span className="text-sm">nexoiotsistemas@gmail.com</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Córdoba Office */}
                    <div className="group">
                      <div className="bg-gradient-to-br from-indigo-500/20 to-purple-600/20 rounded-2xl p-6 border border-indigo-400/20 hover:border-indigo-400/40 transition-all duration-300">
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center mr-4">
                            <MapPin className="w-6 h-6 text-white" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold text-lg">Córdoba</h4>
                            <p className="text-indigo-200 text-sm">Sucursal</p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center text-indigo-100">
                            <Phone className="w-4 h-4 mr-3 text-indigo-400" />
                            <span className="text-sm">+54 9 351 2159511</span>
                          </div>
                          <div className="flex items-center text-indigo-100">
                            <MapPin className="w-4 h-4 mr-3 text-indigo-400" />
                            <span className="text-sm">Córdoba, Argentina</span>
                          </div>
                          <div className="flex items-center text-indigo-100">
                            <Mail className="w-4 h-4 mr-3 text-indigo-400" />
                            <span className="text-sm">nexoiotsistemas@gmail.com</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Features */}
                  <div className="mt-8 grid grid-cols-2 gap-4">
                    <div className="flex items-center text-blue-100">
                      <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
                      <span className="text-sm">Respuesta rápida</span>
                    </div>
                    <div className="flex items-center text-blue-100">
                      <div className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></div>
                      <span className="text-sm">Asesoramiento gratuito</span>
                    </div>
                    <div className="flex items-center text-blue-100">
                      <div className="w-2 h-2 bg-purple-400 rounded-full mr-3"></div>
                      <span className="text-sm">Soporte técnico</span>
                    </div>
                    <div className="flex items-center text-blue-100">
                      <div className="w-2 h-2 bg-cyan-400 rounded-full mr-3"></div>
                      <span className="text-sm">Soluciones personalizadas</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                  <div className="w-3 h-3 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full mr-3"></div>
                  Contacto
                </h3>
                <p className="text-blue-100 mb-8 text-lg">
                  ¿Tenés alguna consulta o querés más información? Escribinos y te responderemos a la brevedad.
                </p>
                
                {/* Enhanced Form Container */}
                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                  <ContactForm />
                </div>
                
                {/* Additional Info */}
                <div className="mt-6 p-4 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-xl border border-green-400/20">
                  <div className="flex items-center text-green-200">
                    <Shield className="w-5 h-5 mr-3 text-green-400" />
                    <span className="text-sm">Tus datos están protegidos y no serán compartidos con terceros.</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Bottom CTA */}
            <div className="text-center mt-16">
              <div className="inline-flex flex-col sm:flex-row items-center gap-4">
                <div className="flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>Llamanos ahora</span>
                </div>
                <div className="text-blue-200 text-sm">
                  o envianos un mensaje y te contactaremos
                </div>
              </div>
            </div>
          </div>
        </section>
       </main>
       <footer className="border-t bg-gray-50">
        <div className="container flex flex-col gap-6 py-8 md:flex-row md:items-center md:justify-between md:py-12 px-6 pr-12">
          <div className="flex items-center gap-2 ml-6">
          <img
              src={iconoSvg}
              width={24}
              height={24}
              className="h-5 w-5"
              alt="Estrella"
            />
            <span className="text-xl font-semibold">NexoIoT</span>
          </div>
        </div>
        <div className="border-t py-6">
          <div className="container flex flex-col items-center justify-center gap-2 md:flex-row md:gap-4">
            <p className="text-center text-sm text-gray-500">
              &copy; {new Date().getFullYear()} NexoIoT. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
       </footer>
    </div>
  );
}
